import { useFeatureFlagVariant } from "@/utils/kameleoon/useFeatureFlagVariant";
export function useIsPhoneNumberValidation() {
    const isPhoneNumberValidationEnabled = useFeatureFlagVariant("cdp_phone_number_validation", "b");
    return isPhoneNumberValidationEnabled;
}
